import { render } from "./UniqueCourse.vue?vue&type=template&id=0a0db200&ts=true"
import script from "./UniqueCourse.vue?vue&type=script&lang=ts"
export * from "./UniqueCourse.vue?vue&type=script&lang=ts"

import "./UniqueCourse.vue?vue&type=style&index=0&id=0a0db200&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__